<template>
  <div class="contact-page">
    <div class="card">
      <div class="title">技术支持 / 联系我们</div>
      <div class="desc">如果您在使用过程中遇到任何问题，或有任何建议和反馈，欢迎通过以下方式联系我们，我们将尽快为您解答。</div>

      <div class="section-title">客户服务</div>

      <div class="item">
        <div class="label">客服邮箱</div>
        <a class="value" href="mailto:support@smartpany.com">support@smartpany.freeqiye.com</a>
      </div>

      <div class="item">
        <div class="label">客服电话</div>
        <a class="value" href="tel:400-800-1234">13584060997</a>
      </div>

      <div class="item">
        <div class="label">工作时间</div>
        <div class="value-text">周一至周五 9:00 - 18:00（法定节假日除外）</div>
      </div>

      <div class="section-title">常见问题</div>

      <div class="faq-item">
        <div class="faq-q">Q: 如何重置密码？</div>
        <div class="faq-a">A: 在登录页面点击"忘记密码"，按照提示操作即可重置密码。</div>
      </div>

      <div class="faq-item">
        <div class="faq-q">Q: 如何联系人工客服？</div>
        <div class="faq-a">A: 您可以发送邮件至 support@smartpany.com，或拨打客服电话 400-800-1234。</div>
      </div>

      <div class="faq-item">
        <div class="faq-q">Q: 如何提交问题反馈？</div>
        <div class="faq-a">A: 您可以通过邮件详细描述您遇到的问题，我们会在1-2个工作日内回复。</div>
      </div>

      <div class="actions">
        <el-button type="primary" @click="goBack">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  methods: {
    goBack() {
      // 如果有历史记录则返回，否则跳转到首页
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-page {
  min-height: 100%;
  width: 100%;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.card {
  width: 560px;
  max-width: 100%;
  background: #ffffff;
  border-radius: 16px;
  padding: 28px 26px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
}

.title {
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 10px;
}

.desc {
  font-size: 14px;
  color: #475569;
  margin-bottom: 18px;
  line-height: 1.6;
}

.item {
  padding: 14px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  margin-bottom: 12px;
}

.label {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 6px;
}

.value {
  font-size: 15px;
  font-weight: 600;
  color: #2563eb;
  text-decoration: none;
  word-break: break-all;
}

.value-text {
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
  margin: 20px 0 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
}

.faq-item {
  margin-bottom: 16px;
}

.faq-q {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 6px;
}

.faq-a {
  font-size: 14px;
  color: #475569;
  line-height: 1.6;
  padding-left: 20px;
}

.actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
</style>
